<template>
 <div>
  <v-dialog :value="show" max-width="600" persistent scrollable content-class="student-situation-window" aria-labelledby="situation-create-title">
   <v-card class="ss-card">
    <div class="ss-header"><div><h2 id="situation-create-title">填写学习状况</h2><p>记录课堂表现、学习进展与下一步计划</p></div><v-btn icon aria-label="关闭填写学习状况" :disabled="submitting" @click="cancel"><v-icon>mdi-close</v-icon></v-btn></div>
    <v-card-text class="ss-body">
     <div class="ss-context"><v-icon size="21">mdi-account-school-outline</v-icon><div><span>学员</span><strong>{{student ? student.studentName : '—'}}</strong></div></div>
     <v-select v-if="classItems.length>1" v-model="classId" :items="classItems" item-text="className" item-value="classId" outlined label="关联班级" placeholder="请选择本次记录对应的班级" color="#d9363e" :disabled="submitting" :error-messages="classError" @change="classError=''"/>
     <div v-else-if="classItems.length===1" class="ss-single-class"><span>关联班级</span><strong>{{classItems[0].className}}</strong></div>
     <v-alert v-else dense outlined type="info">学员暂无在读班级，请先分班后再填写。</v-alert>
     <v-textarea v-model="briefDesc" label="学员学习情况" outlined rows="5" placeholder="例如：本周掌握了哪些内容、需要继续练习的部分，以及下次的学习目标。" color="#d9363e" :disabled="submitting" :error-messages="contentError" @input="contentError=''"/>
     <v-alert v-if="submitError" dense outlined type="error" role="alert">{{submitError}}</v-alert>
    </v-card-text>
    <v-card-actions class="ss-footer"><v-btn outlined :disabled="submitting" @click="cancel">取消</v-btn><v-btn depressed color="#d9363e" dark :loading="submitting" :disabled="!student || !classItems.length" @click="submitAdd">保存记录</v-btn></v-card-actions>
   </v-card>
  </v-dialog>
 </div>
</template>

<script>
export default {
 name: 'create-situation',
 props: { show: { type: Boolean, default: false }, student: { type: Object, default: null }, classItems: { type: Array, default: () => [] } },
 data() { return { classId: '', briefDesc: '', submitting: false, classError: '', contentError: '', submitError: '' } },
 watch: {
  show(value) {
   if (value) {
    this.classId = this.classItems.length===1 ? this.classItems[0].classId : ''
    this.briefDesc = ''; this.classError = ''; this.contentError = ''; this.submitError = ''
   }
  }
 },
 methods: {
  cancel() { if (!this.submitting) this.$emit('cancel', '') },
  async submitAdd() {
   if (this.submitting) return
   this.classError = this.classItems.some(item => item.classId===this.classId) ? '' : '请选择关联班级'
   this.contentError = this.briefDesc.trim() ? '' : '请填写学习情况'
   this.submitError = ''
   if (this.classError || this.contentError || !this.student || !this.student.id) return
   this.submitting = true
   const studentId = String(this.student.id)
   try {
    const response = await this.axios.post('/edu/student/situation/create', { classId: this.classId, studentId, briefDesc: this.briefDesc.trim() })
    if (!response.data || response.data.code!==200) throw new Error((response.data && response.data.message) || '保存失败，请重试')
    if (!this.show || !this.student || String(this.student.id)!==studentId) return
    this.$noty.success('学习状况已保存')
    this.$emit('success', this.briefDesc.trim())
   } catch (error) {
    if (this.show && this.student && String(this.student.id)===studentId) this.submitError = (error && error.message) || '保存失败，请稍后重试'
   } finally { this.submitting = false }
  }
 }
}
</script>

<style scoped lang="scss" src="../assets/styles/student-situation.scss"></style>
